import { createRoot } from 'react-dom/client';
import { App } from '@/app';
import { consumeImpersonationTokenFromUrl } from '@/app/ImpersonationBootstrap';
import '@/app/i18n/config';

// Eagerly populate the in-memory access token from ?impersonationToken=...
// before React mounts. apiFetcher's ensureAuthBootstrap short-circuits when
// a token is already present, which is exactly what we need on an
// impersonation tab — calling /auth/refresh would log the admin out of
// their normal session via the shared HttpOnly tt_refresh cookie.
consumeImpersonationTokenFromUrl();

createRoot(document.getElementById('root')!).render(<App />);
